import { API } from "../../config";
import axios from 'axios';


export const getAdminPurchaseOrders = async (token) => {
    const res = await axios.get(`${API}/v1/purchase_orders`, {
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        }
    });
    if(res.data.success) {
        const purchaseOrders = res.data.purchase_orders.reduce((r,i)=>{
            r.push({
                id: i.id,
                userId: i.user_id,
                supplierId: i.supplier_id,
                warehouseName: i.warehouse_name,
                warehouseAddress: i.warehouse_address,
                deliveryDate: i.delivery_date,
                status: i.status
            });
            return r
        },[]);
        return ({
            success:true,
            purchaseOrders
        })
    } else {
        return ({
            success:false,
            error:res.data.error
        })
    }
};